import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Phone, AlertCircle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

function cleanNumber(num) {
  return (num || "").replace(/[^\d]/g, "");
}

export default function FloatingCtas({ settings }) {
  const wa = cleanNumber(settings?.whatsapp || settings?.phone);
  const phone = settings?.phone || "";
  const { tr } = useLanguage();

  return (
    <>
      {/* Floating WhatsApp (desktop + tablet) */}
      <a
        href={`https://wa.me/${wa}`}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        className="hidden md:flex fixed bottom-6 right-6 z-40 h-14 w-14 items-center justify-center rounded-full bg-civic text-white shadow-xl shadow-civic/30 hover:scale-110 transition-transform animate-float"
        aria-label="WhatsApp"
      >
        <MessageCircle className="h-6 w-6" />
      </a>

      {/* Mobile sticky bottom bar */}
      <div
        className="md:hidden fixed bottom-0 left-0 w-full z-40 bg-white/95 backdrop-blur-md border-t border-gray-200 px-3 py-2.5 flex items-center gap-2 shadow-[0_-4px_20px_rgba(10,25,47,0.08)]"
        data-testid="mobile-cta-bar"
      >
        <a
          href={`https://wa.me/${wa}`}
          target="_blank"
          rel="noreferrer"
          data-testid="mobile-whatsapp"
          className="flex-1 flex flex-col items-center gap-0.5 py-1.5 rounded-xl bg-civic text-white text-xs font-bold"
        >
          <MessageCircle className="h-5 w-5" /> {tr("cta.whatsapp")}
        </a>
        <Link
          to="/submit-ward-issue"
          data-testid="mobile-submit-issue"
          className="flex-1 flex flex-col items-center gap-0.5 py-1.5 rounded-xl bg-gold text-white text-xs font-bold"
        >
          <AlertCircle className="h-5 w-5" /> {tr("cta.submitIssue")}
        </Link>
        <a
          href={`tel:${phone}`}
          data-testid="mobile-call"
          className="flex-1 flex flex-col items-center gap-0.5 py-1.5 rounded-xl bg-navy text-white text-xs font-bold"
        >
          <Phone className="h-5 w-5" /> {tr("cta.call")}
        </a>
      </div>
    </>
  );
}
